<template>
  <div id="app">
    <HeaderComponent></HeaderComponent>
    <router-view :key="$route.fullPath"></router-view>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'App',
  data () {
    return {
      //
    }
  },

  components: {
    HeaderComponent,
    FooterComponent,

  }
}
</script>
